import { defineStore } from 'pinia';

interface LoadingState {
  isLoading: boolean;
}

const userState = (): LoadingState => ({
  isLoading: false,
});

const useLoading = defineStore('loading', {
  state: userState,
  actions: {
    updateLoading(status: boolean) {
      this.isLoading = status;
    }
  },
})

export default useLoading;
